import { network } from 'services/network';

export const extractBattleCardToXls = (params) => {
    return network
        .post(
            'api/bo/extractBattleCardToXls',
            { filterRquest: params.filter, configRequest: params.configRequest },
            {
                responseType: 'blob',
            },
        )
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${params.fileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            return true;
        });
};
